import { GridOn } from "@mui/icons-material"
import PropTypes from "prop-types"
import { Button, Box } from "@mui/material"
import ErrorMessage from "components/error-message"

export default function DataGridErrorFallback({ resetError }) {
  return (
    <Box className="contributors-datagrid">
      <div className="datagrid-error-container">
        <div className="datagrid-error-background">
          <GridOn />
        </div>

        <div className="datagrid-error-content">
          <h3 className="datagrid-error-title">
            There was an error displaying the data table.
          </h3>
          <ErrorMessage
            message=""
            className="datagrid-error-message"
          />
          <Button onClick={resetError} type="button" variant="contained" color="primary">
            Try Again
          </Button>
        </div>
      </div>
    </Box>
  )
}

DataGridErrorFallback.propTypes = {
  resetError: PropTypes.func.isRequired,
}
